import { customDateFormatWithTimezone } from "@/mixins";

export function invoiceBadgeParams(invoice) {
  if (!invoice) {
    return {};
  }
  if (invoice.cancelled) {
    return {
      text: "Cancelled",
      color: "red",
      icon: "fa-circle-x"
    };
  }
  if (invoice.kind === "credit_memo") {
    return {
      text: "Credit Memo",
      color: "yellow",
      icon: "fa-circle-minus"
    };
  }
  if (invoice.voided) {
    return {
      text: "Voided",
      color: "red",
      icon: "fa-circle-x"
    };
  }
  if (invoice.finalized) {
    return {
      text: "Finalized",
      color: "green",
      icon: "fa-circle-check"
    };
  }
  return {
    text: "Pending",
    color: "gray",
    icon: "fa-clock"
  };
}

export function sentBadgeParams(sent_datetime) {
  if (!sent_datetime) {
    return {};
  }
  return {
    text: "Sent",
    color: "green",
    icon: "fa-circle-check",
    tooltipText: `Sent ${customDateFormatWithTimezone(
      sent_datetime,
      "ddd, MM/DD/YYYY - h:mm A"
    )}`
  };
}
